import { MarkdownRenderer } from '@page/core/components/common/markdown/MarkdownRenderer';

/** Strip lightweight markdown markers so search/filter still matches human-readable text. */
export const getPlainLabelText = (label: React.ReactNode): string => {
  if (typeof label !== 'string') return String(label);

  return label
    .replace(/_([^_]+)_/g, '$1')
    .replace(/\*\*([^*]+)\*\*/g, '$1')
    .replace(/\*([^*]+)\*/g, '$1');
};

interface SelectOptionLabelProps {
  label: React.ReactNode;
  markdown?: boolean;
  className?: string;
}

export function SelectOptionLabel({ label, markdown = false, className }: SelectOptionLabelProps) {
  if (!markdown || typeof label !== 'string') {
    return <span className={className}>{label}</span>;
  }

  return (
    <MarkdownRenderer
      content={label}
      className={className}
      preserveSoftLineBreaks
      components={{
        p: ({ children }) => <span className="inline">{children}</span>,
      }}
    />
  );
}
